import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";
export default function DataTable_Component({
  apidata,
  columns,
  searchBy,

  totalRows,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,

  dataFilter,
  setDataFilter,

  statusFilter,
  setStatusFilter,

  vehicleCompanyFilter,
  setVehicleCompanyFilter,

  hubFilter,
  setHubFilter,

  monthFilter,
  setMonthFilter,

  ticketCategoryFilter,
  setTicketCategoryFilter,

  ticketAgingFilter,
  setTicketAgingFilter,

  leasingPartnerFilter,
  setLeasingPartnerFilter,
  leasingPartners,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [hubs, setHubs] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setHubs(res.data.hubs || []);
      } catch (err) {
        console.error("Hub fetch error", err);
      }
    };

    fetchHubs();
  }, []);

  useEffect(() => {
    const fetchVehicleTypes = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-types`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setVehicleTypes(res.data.vehicleType || []);
      } catch (err) {
        console.error("VehicleType fetch error", err);
      }
    };

    fetchVehicleTypes();
  }, []);

  const applyFilters = () => {
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setStatusFilter("");
    setVehicleCompanyFilter("");
    setHubFilter([]);
    setMonthFilter("");
    setTicketCategoryFilter("");
    setTicketAgingFilter("");
    setLeasingPartnerFilter("");
    setDataFilter("");
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>

        <div className="col-md-9 mb-2 d-flex align-items-center">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={apidata}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage) => {
          setRowsPerPage(newPerPage);
        }}
        fixedHeader
        highlightOnHover
        responsive
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        vehicleCompanyFilter={vehicleCompanyFilter}
        setVehicleCompanyFilter={setVehicleCompanyFilter}
        hubFilter={hubFilter}
        setHubFilter={setHubFilter}
        monthFilter={monthFilter}
        setMonthFilter={setMonthFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        hubs={hubs}
        vehicleTypes={vehicleTypes}
        ticketCategoryFilter={ticketCategoryFilter}
        setTicketCategoryFilter={setTicketCategoryFilter}
        ticketAgingFilter={ticketAgingFilter}
        setTicketAgingFilter={setTicketAgingFilter}
        leasingPartnerFilter={leasingPartnerFilter}
        setLeasingPartnerFilter={setLeasingPartnerFilter}
        leasingPartners={leasingPartners}
        // apidata={apidata}
      />
    </div>
  );
}
